import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async fetchConfigurations({ commit }, { pId, vId, pvId, sInfo = false }) {
    Vue.$log.debug('loading pdf configuration for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '') + '&sInfo=' + (sInfo || false);
    return Vue.axios.get(Vue.$url("pdf-configuration" + query))
      .then((rsp) => commit("SET_PDF_CONFIGURATIONS", rsp.data));
  },

  async updateConfiguration({ commit }, payload) {
    return Vue.axios.put(Vue.$url("pdf-configuration/" + payload.id), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'PdfConfiguration', 1: i18n.t(payload.columnDescription) }), { root: true });
        return rsp.data;
      })
  },

  async toggleConfiguration({ commit }, payload) {
    return Vue.axios.put(Vue.$url("pdf-configuration/" + payload.id + "/toggle-state?visible=" + payload.visible))
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'PdfConfiguration', 1: i18n.t(payload.columnDescription) }), { root: true });
        return rsp.data;
      })
  },
}